import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center lg:items-start gap-3">
            <Link
              to="/"
              className="font-heading text-xl font-bold text-foreground-900 hover:text-primary-600 transition-colors duration-200"
            >
              {t("nav.brand")}
            </Link>
            <p className="text-sm text-foreground-500 max-w-md text-center lg:text-left">
              {t("footer.disclaimer")}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              {t("hero.cta.pandabuy")}
            </a>
            <Link
              to="/pandabuy-spreadsheet-ultimate-guide"
              className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              {t("article.readmore")}
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">{t("footer.copyright")}</p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors duration-200 whitespace-nowrap">
              {t("footer.privacy")}
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors duration-200 whitespace-nowrap">
              {t("footer.terms")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}